import { Checkbox } from 'rsuite';
import styled from 'styled-components';
import { INFO_BOX_SUBTITLE_COLORS } from '../map-constants';
import { StyledMapButton } from './map-control-styles';

const RowFlex = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ShrinkActionWrapper = styled(RowFlex)`
  width: 100%;
  justify-content: flex-end;
  padding-right: 8px;
`;
export const SummaryWrapper = styled.div`
  cursor: default;
  position: absolute;
  top: 0px;
  right: 0;
  min-width: 386px;
  padding-top: 8px;
  padding-left: 30px;
  border-radius: 6px;
  box-shadow:
    0 2px 3px 0 rgba(8, 10, 37, 0.03),
    0 4px 8.5px 0 rgba(8, 10, 37, 0.05),
    0 7.5px 35px 0 rgba(89, 126, 247, 0.03);
  background-color: rgba(16, 25, 56, 0.55);
  backdrop-filter: blur(6px);
  font-family: 'Nunito Sans';

  display: flex;
  flex-direction: column;
`;

export const TotalText = styled(RowFlex)`
  width: 100%;
  height: 14px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: rgba(255, 255, 255, 0.85);
  margin-top: 20px;

  display: flex;
  align-items: center;
`;

export const PlatformStatsWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 10px;
  grid-column-gap: 22px;
  margin-top: 20px;
  padding-right: 20px;
`;

export const ListingSummaryBtn = styled(StyledMapButton)`
  margin-top: 20px !important;
  margin-right: 20px !important;
  width: ${(props) => (props.expanded ? '296px' : '32px')};
  background-color: ${(props) =>
    props.expanded ? '#fafbfe' : 'rgba(16, 25, 56, 0.5)'};
  border-radius: 4px;
  padding: 0px;
  cursor: ${(props) => (props.expanded ? 'grab' : 'cursor')};
`;

export const DisclaimerContent = styled.div`
  display: block;
  text-align: left;
  width: 100%;
  padding-right: 30px;
  margin-bottom: 20px;

  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: rgba(255, 255, 255, 0.65);
`;

export const ListingPerPlatformWrapper = styled.div`
  height: 14px;
  white-space: nowrap;
  font-size: 14px;

  display: flex;
  align-items: center;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.85);
`;

export const CityNameText = styled(RowFlex)`
  display: flex;
  width: 100%;
  height: 14px;
  margin-top: 6px;
  color: #ffffff;

  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
`;

export const CityNameSubtitle = styled.div`
  width: 100%;
  display: flex;
  height: 16px;
  align-items: center;
  margin-top: 5px;

  ::before {
    content: '${(props) => props.subtitle}';
    font-size: 10px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    color: ${(props) => INFO_BOX_SUBTITLE_COLORS[props.cityMode]};
    border-radius: 2px;
    border: solid 1px ${(props) => INFO_BOX_SUBTITLE_COLORS[props.cityMode]};
    padding: 3px 5px;
  }
`;

export const CityNameWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const DashedLine = styled.div`
  height: 1px;
  border: dashed 1px #c7c7c7;
  margin-top: 20px;
  margin-right: 20px;
`;

export const DotCaptionWrapper = styled.div`
  display: grid;
  grid-row-gap: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const Dot = styled.div`
  height: 14px;
  width: 14px;
  border: solid #fff 1px;
  border-radius: 50%;
  box-shadow:
    0 2px 3px 0 rgba(8, 10, 37, 0.03),
    0 4px 8.5px 0 rgba(8, 10, 37, 0.05),
    0 7.5px 35px 0 rgba(89, 126, 247, 0.03);
  background-color: ${(props) => props.color};
  margin-right: 10px;
`;

export const DotDescription = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 14px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: rgba(255, 255, 255, 0.85);
`;

export const CheckboxWrapper = styled.div`
  height: 14px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-left: -10px;
  color: rgba(255, 255, 255, 0.85);

  .rs-checkbox-checker {
    display: flex;
    align-items: center;
  }
`;

export const IncludeCitiesNoticeText = styled.div`
  text-align: left;
  font-size: 12px;
  color: #ffffff;
`;
